import { useState } from "react";
import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import CategorySection from "@/pages/home/components/CategorySection";
import MovieSection from "@/pages/home/components/MovieSection";
import LibrarySection from "@/pages/home/components/LibrarySection";
import NovelComicSection from "@/pages/home/components/NovelComicSection";
import AudioSection from "@/pages/home/components/AudioSection";
import RankingSection from "@/pages/home/components/RankingSection";
import AdFreeSection from "@/pages/home/components/AdFreeSection";
import SceneSection from "@/pages/home/components/SceneSection";
import FaqSection from "@/pages/home/components/FaqSection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  const [query, setQuery] = useState("");

  const scrollToLibrary = () => {
    const el = document.getElementById("library");
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="w-full min-h-screen bg-background-50 text-foreground-950">
      <Navbar />
      <main>
        <Hero query={query} onQueryChange={setQuery} onSearch={scrollToLibrary} />
        <CategorySection />
        <MovieSection />
        <LibrarySection query={query} onQueryChange={setQuery} />
        <NovelComicSection />
        <AudioSection />
        <RankingSection />
        <AdFreeSection />
        <SceneSection />
        <FaqSection />
      </main>
      <Footer />
    </div>
  );
}